<template>
  <thead>
  <tr>
    <th colspan="5" class="border-r" style="border-bottom: 0"></th>
    <th colspan="4" class="border-r" style="border-bottom: 0">
      <div class="text-center">Última Entrada</div>
    </th>
    <th class="border-r" style="border-bottom: 0">
      <div class="text-center">Preços (R$)</div>
    </th>
    <th colspan="4" class="border-r" style="border-bottom: 0">
      <div class="text-center">Qtde. Venda Últimos Meses</div>
    </th>
    <th colspan="2" class="border-r font-12" style="border-bottom: 0">
      <div class="text-center">Estoques</div>
    </th>
    <th class="border-r">ICMS</th>
    <th colspan="6" class="border-r font-12" style="border-bottom: 0">
      <div class="text-center">Alíquota</div>
    </th>
    <th colspan="3" style="border-bottom: 0"></th>
  </tr>
  </thead>
</template>

<script>
export default {
  name: "CabecalhoGruposItens"
}
</script>

<style scoped>

</style>
